export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_07.81594ec7.jpg";